import { Loader2, ShieldAlert } from 'lucide-react';
import PlacaDisplay from './veiculo/PlacaDisplay';
import { ErrorToast } from './veiculo/Modals';
import { useExclusaoOrchestrator } from '../hooks/useExclusaoOrchestrator';
import { CheckCircle, XCircle } from 'lucide-react';
import { formatarMotivoExclusao } from '../utils/formatters';

const StatusModal = ({ title, message }) => (
  <div className="fixed inset-0 z-[200] bg-black/60 flex items-center justify-center px-4">
    <div className="bg-white rounded-xl shadow-2xl p-4 sm:p-6 max-w-sm w-full text-center animate-fade-in">
      <ShieldAlert className="mx-auto w-10 h-10 sm:w-16 sm:h-16 text-yellow-500 mb-4" />
      <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
        {title}
      </h2>
      <p className="text-gray-600 text-sm sm:text-base">{message}</p>
    </div>
  </div>
);

const ExclusaoForm = () => {
  const { exclusaoData, loading, errorInfo, handleConfirmar, handleRejeitar } =
    useExclusaoOrchestrator();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader2 className="h-12 w-12 animate-spin" />
      </div>
    );
  }

  const status = errorInfo.status;
  if (!exclusaoData) {
    const titulo =
      status === 410
        ? 'Link Expirado'
        : status === 404
          ? 'Acesso Negado'
          : 'Não foi possível carregar';
    const msg =
      errorInfo.message ||
      (status === 410
        ? 'O link que você tentou acessar expirou.'
        : 'O link que você tentou acessar é inválido.');
    return <StatusModal title={titulo} message={msg} />;
  }

  return (
    <div className="bg-neutral-100 rounded-lg shadow-lg p-4 md:p-8 border border-slate-400">
      <div className="text-center mb-8">
        <h1 className="flex flex-col items-center text-3xl md:text-3xl font-bold text-gray-700">
          <div>Solicitação de Exclusão</div>
          <div className="text-2xl mt-2 text-gray-600">
            <span>{exclusaoData?.escritorio?.nome}</span>
          </div>
        </h1>
      </div>

      <div className="flex flex-col items-center gap-4 w-full px-4">
        <PlacaDisplay placa={exclusaoData?.placa} />

        <div className="w-full max-w-md mx-auto mt-4 sm:mt-6">
          <p className="text-lg sm:text-xl text-center font-medium text-gray-700 mb-2">
            Motivo da exclusão:
          </p>
          <div className="bg-white border border-slate-300 rounded-lg shadow-sm p-4 text-center">
            <p className="text-xl font-bold text-gray-800">
              {formatarMotivoExclusao(exclusaoData?.situacao)}
            </p>
            {exclusaoData?.detalhe ? (
              <p className="text-sm sm:text-base text-gray-600 mt-2">
                {exclusaoData.detalhe}
              </p>
            ) : null}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4 w-full max-w-md mx-auto mt-6 sm:mt-8">
          <button
            onClick={handleRejeitar}
            className="group flex items-center justify-center gap-3 font-bold text-base sm:text-lg py-3 px-6 sm:px-8 rounded-lg shadow-lg bg-gradient-to-r from-red-500 to-red-600 text-white hover:scale-105 transition duration-200"
          >
            <XCircle size={20} className="sm:w-7 sm:h-7" />
            <span>Não Excluir</span>
          </button>
          <button
            onClick={handleConfirmar}
            className="group flex items-center justify-center gap-3 font-bold text-base sm:text-lg py-3 px-6 sm:px-8 rounded-lg shadow-lg bg-gradient-to-r from-green-500 to-green-600 text-white hover:scale-105 transition duration-200"
          >
            <CheckCircle size={20} className="sm:w-7 sm:h-7" />
            <span>Confirmar Exclusão</span>
          </button>
        </div>
      </div>

      <ErrorToast message={errorInfo.message} show={errorInfo.show} />
    </div>
  );
};

export default ExclusaoForm;
